import "./Shop.module.css";
import AutoMotiGalvene from "@/reusable_sections/Header";
import ShopTitle from "./sections/ShopTitle";
import ShopContent from "./sections/ShopContent";
import Footer from "@/reusable_sections/Footer";
export default function ShopPage() {
  return <div>
      <AutoMotiGalvene />
      <ShopTitle />
      <ShopContent />
      <Footer />
    </div>;
}